import tw from 'twin.macro';
import styled from 'styled-components';

export const Section = tw.div`
 py-24 sm:py-28
`;


export const PropertiesContainer = tw.div`
  flex flex-wrap p-5 mx-auto max-w-7xl px-6 lg:px-8
`;

export const PropertyCard = tw.div`
  mx-auto bg-white border rounded shadow max-w-sm flex-1 basis-1/3
`;

export const ImageWrapper = styled.div`
  ${tw`relative`}
`;

export const PropertyImage = styled.img`
  ${tw`w-full object-cover`}
  max-height: 250px;
`;

export const Badge = tw.div`
   absolute top-0 right-0 bg-black text-white px-2 py-1 font-bold
`;

export const CardBody = tw.div`
  p-4 text-center
`;

export const PropertyLink = tw.a`
  no-underline text-black font-bold hover:underline
`;

export const Address = tw.p`
  font-semibold
`;

export const Features = tw.p`
  font-semibold
`;

export const FeatureSeparator = tw.span`
  inline-block mx-1
`;

export const Price = tw.p`
  font-semibold
`;
